import { call, put, takeEvery, takeLatest } from "redux-saga/effects";

// Login Redux States
import { LOGIN_USER, LOGOUT_USER, SOCIAL_LOGIN } from "./actionTypes";
import { apiError, loginSuccess, logoutUserSuccess } from "./actions";

//Include Both Helper File with needed methods
import { getFirebaseBackend } from "../../../helpers/firebase_helper";
import {
  postFakeLogin,
  postJwtLogin,
  postSocialLogin,
} from "../../../helpers/fakebackend_helper";
import { toast } from "react-toastify";

const fireBaseBackend = getFirebaseBackend();

function* loginUser({ payload: { user, history } }) {
  try {
    let response;

    if (process.env.REACT_APP_DEFAULTAUTH === "jwt") {
      response = yield call(postJwtLogin, {
        email: user.email,
        password: user.password,
      });
      localStorage.setItem("authUser", JSON.stringify(response.value[0]));
      yield put(loginSuccess(response));
      toast.success("Giriş Başarılı!");
    } 
    
    else if (process.env.REACT_APP_DEFAULTAUTH === "fake") {
      response = yield call(postFakeLogin, {
        email: user.email,
        password: user.password,
      });

      console.log("lkmsdlfs",response)
      // API'den dönen response dizisinin boş olup olmadığını kontrol edelim
      if (response && response.value.length > 0) {
        const userData = response.value[0];
        localStorage.setItem("authUser", JSON.stringify(userData));
        yield put(loginSuccess(userData));
        
        toast.success("Hoşgeldiniz! Panale yönlendiriliyorsunuz.");

        // Yönlendirme mantığı
        if (userData.UserTypeID === 1) {
          history('/dashboard');
        } else if (userData.UserTypeID === 3) {
          history('/dashboardRest');
        } else {
          history('/dashboard');
        }
      } else {
        // Eğer dizi boşsa kullanıcı bulunamamıştır
        const errorMsg = "Hatalı Giriş! Lütfen bilgilerinizi kontrol edin.";
        yield put(apiError(errorMsg));
        toast.error(errorMsg);
      }
    }
  } catch (error) {
    // Saga'nın tamamen çökmesini engelleyen catch bloğu
    console.error("Login Error:", error);
    const generalError = "Sunucu ile bağlantı kurulamadı.";
    yield put(apiError(generalError));
    toast.error(generalError);
  }
}


function* logoutUser({ payload: { history } }) {
  try {
    localStorage.removeItem("authUser");

    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      const response = yield call(fireBaseBackend.logout);
      yield put(logoutUserSuccess(response));
    }
    history('/login');
  } catch (error) {
    yield put(apiError(error));
  }
}

function* socialLogin({ payload: { type, history } }) {
  try {
    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      const fireBaseBackend = getFirebaseBackend();
      const response = yield call(fireBaseBackend.socialLoginUser, type);
      if (response) {
        history("/dashboard");
      } else {
        history("/login");
      }
      localStorage.setItem("authUser", JSON.stringify(response));
      yield put(loginSuccess(response));
    }
    if(response)
    history("/dashboard");
  } catch (error) {
    console.log("error",error)
    yield put(apiError(error));
  }
}

function* authSaga() {
  yield takeEvery(LOGIN_USER, loginUser);
  yield takeLatest(SOCIAL_LOGIN, socialLogin);
  yield takeEvery(LOGOUT_USER, logoutUser);
}

export default authSaga;
